export default __webpack_public_path__ + "static/media/JP Thanga & Velli Maaligai.5c636ad4.jpg";